import {CanActivateFn, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {AuthState} from './auth-state.enum';
import {AuthService} from './auth.service';
import {inject} from '@angular/core';

/**
 * It only lets you in if you're logged
 */
export const loggedInGuard: CanActivateFn = (route, state) => {
  const auth: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  if (!auth.token) {
    return router.createUrlTree(auth.signInPageUrl);
  }

  return auth.getActualState().pipe(
    map(state => {
      return state === AuthState.LOGGED_IN ? true : router.createUrlTree(auth.signInPageUrl);
    }),
  );
};
